import {STATE_PROP_NAME} from './dashboard-constants'

export const getState = state => state[STATE_PROP_NAME]
export const getHealthChangeTable = state => getState(state).healthChangeTable
